import React from "react";
import { LoadingSpinner } from "shared";
import parse from "html-react-parser";
import { useTermsAndCondition } from "..";

export const TermsCondition = () => {
  const { settingsInfo } = useTermsAndCondition({
    load: true,
    key: "page_terms",
  });
  const { data, isLoading } = settingsInfo;

  if (isLoading) return <LoadingSpinner />;

  return (
    <div className="terms-faq-privacy-section">
      <div className="page-header-left col-12 col-md-8 pb-5">
        <h2 className="page-title ellipsis-text">Terms And Conditions</h2>
      </div>
      <p>{data ? parse(data?.content) : ""}</p>
    </div>
  );
};
